import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

export default function BackToSignIn() {
  const { t } = useTranslation()

  return (
    <div className="border-mauve-6 mt-6 border-t border-solid py-6 text-center">
      <p className="text-2">
        {t('forgotPassword.abortPasswordReset')}{' '}
        <Link className="text-cyan-11" to="/sign-in">
          {t('forgotPassword.abortPasswordResetLinkText')}
        </Link>
        .
      </p>
    </div>
  )
}
